export default __webpack_public_path__ + "static/media/q9_10_v2.18d98efa.png";